import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell as TableCellBase,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow as TableRowBase,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import {
    methodGetSimulateScoreRank,
    methodGetUsedTimeRank,
} from "../../../../../../api/apirank/api";
import { AlertSuccess } from "../../../../../../component/basic/feedbacks/snackbar/Snackbar";
import {
    ScoreData,
    ScoreTop,
    TimeData,
    TimeTop,
} from "../../../../../../model/statistic/rank/RankTop";
import { selectUserID } from "../../../../../../store/user/selector";
import { Colors } from "../../../../../../tools/color";
import { useAPIRsp } from "../../../../../../tools/use_api_data";

export function Rank() {
    const [scoreRsp, refreshScore] = useAPIRsp(
        methodGetSimulateScoreRank,
        {},
        { top: new ScoreTop(), user: new ScoreData() }
    );
    const [timeRsp, refreshTime] = useAPIRsp(
        methodGetUsedTimeRank,
        {},
        { top: new TimeTop(), user: new TimeData() }
    );
    const st = scoreRsp.top;
    const tt = timeRsp.top;

    return (
        <Box
            sx={{
                width: "50%",
                display: "flex",
                m: "10px",
            }}
        >
            <Box sx={{ width: "22%" }}>
                <LastRank topScore={st.last_top} topTime={tt.last_top} />
            </Box>
            <Box sx={{ width: "78%" }}>
                <TodayRanks
                    scoreTop={st}
                    scoreUser={scoreRsp.user}
                    timeTop={tt}
                    timeUser={timeRsp.user}
                    refresh={() => {
                        Promise.all([refreshScore(), refreshTime()]).then(() => {
                            AlertSuccess("刷新成功");
                        });
                    }}
                />
            </Box>
        </Box>
    );
}

function LastRank(props: { topScore: ScoreData; topTime: TimeData }) {
    const curUserID = useSelector(selectUserID);

    const { topScore, topTime } = props;

    const display = topScore.user_name.length > 0 && topTime.user_name.length > 0;
    return (
        <Box sx={{ height: "100%" }}>
            {display && (
                <Box
                    sx={{
                        display: "flex",
                        height: "100%",
                        flexDirection: "column",
                    }}
                >
                    <Box sx={{ height: "60px", ml: "-15px", position: "relative" }}>
                        <Box
                            sx={{
                                position: "absolute",
                                left: "10px",
                                top: "10px",
                                height: "35px",
                                width: "35px",
                                borderRadius: "50%",
                                background: Colors["primarya"],
                            }}
                        />
                        <Box
                            sx={{
                                position: "absolute",
                                left: "20px",
                                top: "20px",
                                fontSize: "1.2rem",
                            }}
                        >
                            <b>昨日冠军</b>
                        </Box>
                    </Box>
                    <GoldDisplay data={scoreToDisplay(topScore, curUserID)} />
                    <GoldDisplay data={timeToDisplay(topTime, curUserID)} />
                    <p>🎁请滴滴客服领3天超大</p>
                </Box>
            )}
        </Box>
    );
}

function GoldDisplay(props: { data: RankDisplay }) {
    const { data } = props;
    return (
        <>
            <Box sx={{ color: Colors["gold"], display: "flex", alignItems: "center" }}>
                <WorkspacePremiumIcon />
                &nbsp;
                {data.name_display}
                &nbsp;
                {data.content_display}
            </Box>
        </>
    );
}

interface RankDisplay {
    order: number;
    user_id: string;
    name_display: any;
    content_display: string;
}

function TodayRanks(props: {
    scoreTop: ScoreTop;
    scoreUser: ScoreData;
    timeTop: TimeTop;
    timeUser: TimeData;
    refresh: () => void;
}) {
    const { scoreTop, scoreUser, timeTop, timeUser, refresh } = props;
    const curUserID = useSelector(selectUserID);
    return (
        <Box>
            <Box sx={{ display: "flex" }}>
                <Box sx={{ width: "50%" }}>
                    <RankTable
                        top={scoreTop.datas.map((d) => scoreToDisplay(d, curUserID))}
                        user={scoreToDisplay(scoreUser, curUserID)}
                        title="模考成绩"
                    />
                </Box>
                <Box sx={{ width: "50%" }}>
                    <RankTable
                        top={timeTop.datas.map((d) => timeToDisplay(d, curUserID))}
                        user={timeToDisplay(timeUser, curUserID)}
                        title="练题时长"
                    />
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",

                    fontSize: 11,
                    color: Colors["bbgray4"],
                    mt: "2px",
                }}
            >
                <Button
                    size="small"
                    color="bbgray"
                    onClick={() => {
                        refresh();
                    }}
                    sx={{
                        fontSize: 10,
                        mr: "15px",
                        pl: "6px",
                        pr: "6px",
                        pt: "2px",
                        pb: "2px",
                        minWidth: "30px",
                    }}
                >
                    刷新榜单
                </Button>
                榜单每日北京时间24点重置
            </Box>
        </Box>
    );
}

function RankTable(props: { title: string; top: RankDisplay[]; user: RankDisplay }) {
    const { top, user, title } = props;

    const makeColor = (d: RankDisplay, onlyGold?: boolean) => {
        if (d.user_id === user.user_id) {
            return Colors["primary"];
        }
        if (d.order === 1) {
            return Colors["gold"];
        }
        if (!onlyGold && d.order === 2) {
            return Colors["silver"];
        }
        if (!onlyGold && d.order === 3) {
            return Colors["bronze"];
        }
        return undefined;
    };

    const makeBlod = (order: number) => {
        if (order <= 3) {
            return 700;
        }
        return undefined;
    };
    return (
        <Box sx={{ m: "5px" }}>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>排名</TableCell>
                            <TableCell>用户</TableCell>
                            <TableCell>{title}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <Box
                                    sx={{
                                        minWidth: "24px",
                                        color: Colors["primary"],
                                        fontSize: 16,
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <b>
                                        {user.content_display === "无" && "无"}
                                        {user.content_display !== "无" &&
                                            (user.order === 0 ? "100+" : user.order)}
                                    </b>
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Box
                                    sx={{ color: Colors["primary"], fontSize: 16, fontWeight: 700 }}
                                >
                                    {user.name_display}
                                </Box>
                            </TableCell>
                            <TableCell>
                                <span style={{ color: Colors["primary"], fontSize: 16 }}>
                                    <b>{user.content_display}</b>
                                </span>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        {top.map((d, index) => (
                            <TableRow key={index}>
                                <TableCell
                                    sx={{
                                        color: makeColor(d),
                                        fontWeight: makeBlod(d.order),
                                    }}
                                >
                                    <Order order={d.order} />
                                </TableCell>
                                <TableCell
                                    sx={{
                                        color: makeColor(d, true),
                                        fontWeight: makeBlod(d.order),
                                    }}
                                >
                                    {d.name_display}
                                </TableCell>
                                <TableCell
                                    sx={{
                                        color: makeColor(d, true),
                                        fontWeight: makeBlod(d.order),
                                    }}
                                >
                                    {d.content_display}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

function Order(props: { order: number }) {
    const { order } = props;
    return (
        <Box sx={{ minWidth: "24px", display: "flex", justifyContent: "center" }}>
            {order <= 3 && <WorkspacePremiumIcon />}
            {order > 3 && order}
        </Box>
    );
}

const TableCell = styled(TableCellBase)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "white",
        color: "black",
        fontWeight: 700,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const TableRow = styled(TableRowBase)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const makeNameShort = (user_name: string) => {
    if (user_name.length === 1) {
        return user_name;
    }
    if (user_name.length >= 5) {
        return user_name.substring(0, 3) + "**";
    }
    if (user_name.length > 2) {
        return user_name.substring(0, user_name.length - 1) + "*";
    }
    return user_name;
};

const makeNameDisplay = (user_name: string, isUser: boolean) => {
    const nameShort = makeNameShort(user_name);
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                ...(isUser
                    ? {
                          color: Colors["primary"],
                          fontWeight: 700,
                      }
                    : {}),
            }}
        >
            {nameShort}
            {isUser && (
                <Box
                    sx={{
                        ml: "4px",
                        borderRadius: "7px",
                        width: "20px",
                        height: "15px",
                        fontSize: 10,
                        background: Colors["primary"],
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <b>我</b>
                </Box>
            )}
        </Box>
    );
};

function scoreToDisplay(d: ScoreData, curUserID: string): RankDisplay {
    return {
        ...d,
        name_display: makeNameDisplay(d.user_name, curUserID === d.user_id),
        content_display: d.score > 0 ? d.score.toFixed(0) : "无",
    };
}

function timeToDisplay(d: TimeData, curUserID: string): RankDisplay {
    return {
        ...d,
        name_display: makeNameDisplay(d.user_name, curUserID === d.user_id),
        content_display: d.used_time.length > 0 ? d.used_time : "无",
    };
}
